import React, { useState } from "react";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Menu } from "@mui/material";
import { MenuItem } from "@mui/material";
import CardWrapper from "../../components/card-wrapper/card-wrapper";
import Typography from "../typography/typography";
import SearchBar from "../search-bar/search-bar";
import images from "../../assets/images";

import "./multiline.scss";

interface Option {
  id: number;
  name: string;
  role: string;
}
interface MultiProps {
  options: Option[];
}

export const MultiLine = (props: MultiProps) => {
  const { options } = props;
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearchEvent = (searchQuery: string) => {
    const lowerCaseQuery = searchQuery.toLowerCase();
    const filtered = options.filter((option: Option) => {
      return (
        option.name.toLowerCase().includes(lowerCaseQuery) ||
        option.role.toLowerCase().includes(lowerCaseQuery)
      );
    });
    setFilteredOptions(filtered);
  };

  const handleCreateClick = () => {
    alert("Clicked ");
  };

  return (
    <div className="main-card-nodal">
      <CardWrapper>
        <div className="payable-header">
          <Typography className="payable-title">Payable Account</Typography>
          <IconButton color="inherit" size="small" onClick={handleClick}>
            <img src={images.more} alt="more icon" />
          </IconButton>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem onClick={handleClose}>View</MenuItem>
          </Menu>
        </div>
        <SearchBar
          placeholder="Search Companies"
          handleSearch={(e) => {
            handleSearchEvent(e);
          }}
          debounceTime={1}
        />
        {filteredOptions.map((option: Option) => (
          <div key={option.id} className="list-items">
            <Typography className="title">{option.name}</Typography>
            <Typography className="description">{option.role}</Typography>
          </div>
        ))}

        <div className="bottom-footer" onClick={handleCreateClick}>
          <AddIcon />
          <Typography>Create a Cost Center</Typography>
        </div>
      </CardWrapper>
    </div>
  );
};

export default MultiLine;
